import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || 'https://high.innohed.com/api';

const api = axios.create({
  baseURL: API_BASE,
  timeout: 60000,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const authAPI = {
  login: (username: string, password: string) =>
    api.post('/v1/auth/login', { username, password }),
};

export const accountAPI = {
  getAll: () => api.get('/v1/accounts'),
  getABook: () => api.get('/v1/accounts/a-book'),
  getOne: (accountId: string) => api.get(`/v1/accounts/${accountId}`),
  getHistory: (accountId: string) => api.get(`/v1/accounts/${accountId}/history`),
  returnToBBook: (accountId: string) => api.post(`/v1/accounts/${accountId}/return-to-b`),
  getAccountsByGroup: (group: string) => api.get(`/v1/accounts/groups/accounts?group=${encodeURIComponent(group)}`),
  getGroups: () => api.get('/v1/accounts/groups'),
  register: (data: any) => api.post('/v1/accounts', data),
  health: () => api.get('/v1/accounts/health'),
};

export const rulesAPI = {
  getAll: () => api.get('/v1/rules'),
  create: (data: any) => api.post('/v1/rules', data),
  update: (id: number, data: any) => api.put(`/v1/rules/${id}`, data),
  delete: (id: number) => api.delete(`/v1/rules/${id}`),
};

export const positionAPI = {
  getFloating: () => api.get('/v1/positions/floating'),
  getByAccount: (accountId: string) => api.get(`/v1/positions/${accountId}`),
};

export const patternAPI = {
  getRecommendations: () => api.get('/v1/pattern/recommendations'),
  getBBookRecommendations: () => api.get('/v1/pattern/recommendations/b-book'),
  getABookRecommendations: () => api.get('/v1/pattern/recommendations/a-book'),
  getAccountPattern: (login: string) => api.get(`/v1/pattern/${login}`),
  getShortHighWinRate: () => api.get('/v1/pattern/short-high-winrate'),
  getLongStable: () => api.get('/v1/pattern/long-stable'),
  getHighPayoff: () => api.get('/v1/pattern/high-payoff'),
  getNormalLoss: () => api.get('/v1/pattern/normal-loss'),
  getAccountSnapshot: (login: number) => api.get(`/v1/pattern/account/${login}/snapshot`),
  getAccountDaily: (login: number) => api.get(`/v1/pattern/account/${login}/daily`),
  getAccountThreshold: (login: number) => api.get(`/v1/pattern/account/${login}/threshold`),
};

// 정합성 검증 API - 트레이더 측 거래/포지션과 마스터 측 실제 MT5 데이터 비교
// 헷지 불일치 감지 API
export const mismatchAPI = {
  list: (params: any) => api.get('/v1/mismatch', { params }),
  resolve: (id: number, note?: string) => api.post(`/v1/mismatch/${id}/resolve`, { note }),
  triggerDetect: () => api.post('/v1/mismatch/trigger'),
};

export const reconciliationAPI = {
  getPending: (params: any) => api.get('/v1/reconciliation/pending', { params }),
  getPositions: (params: any) => api.get('/v1/reconciliation/positions', { params }),
  getDeals: (params: any) => api.get('/v1/reconciliation/deals', { params }),
  getZombies: (params: any) => api.get('/v1/reconciliation/zombies', { params }),
  getAccounts: (params?: any) => api.get('/v1/reconciliation/accounts', { params }),
  getSymbols: () => api.get('/v1/reconciliation/symbols'),
  getRules: () => api.get('/v1/reconciliation/rules'),
};

export default api;
